(ns admin.components.composite.table
  (:require
   [reagent.core :as reagent]

   [kyber.components.base.text :as text]
   [kyber.components.base.button :as button]
   [kyber.utils :as ku]
   [kyber.styles.core :refer [styles->classes gs]]))

(def cell-padding
  [(gs [:spacing :p2])
   (gs [:spacing :p8])])

(def classes
  (styles->classes
   {:table-body-container
    {:border (str "1px solid " (gs [:colors :gray-scale-200]))}

    :table-row-container
    {"&:nth-child(even)"
     {:background-color (gs [:colors :gray-scale-50])}}

    :table-header-cell-container
    {:padding cell-padding}

    :table-cell-container
    {:padding cell-padding
     :border (str "1px solid " (gs [:colors :gray-scale-200]))}}))

(defn- update-sort-order
  [sort-order sort-key]
  (let [current-direction
        (get-in @sort-order [sort-key :direction])

        next-direction
        (if (= current-direction :asc)
          :desc :asc)

        updated-sort-order
        (->> @sort-order
             vals
             (sort-by :sort-priority)
             (map :key)
             (remove #(= sort-key %))
             (into [sort-key])
             (map-indexed (fn [idx header-key]
                            {:sort-priority (inc idx)
                             :key header-key})))]
    (reset!
     sort-order
     (reduce
      (fn [acc {:keys [key sort-priority]}]
        (cond-> (assoc-in acc [key :sort-priority] sort-priority)
          (= key sort-key)
          (assoc-in [sort-key :direction] next-direction)))
      @sort-order
      updated-sort-order))))

(defn- get-default-sort-order
  [headers]
  (ku/coll->dictionary
   (->> headers
        (filter #(-> % :hide-sort boolean false?))
        (map-indexed (fn [idx {:keys [key]}] {:direction :desc
                                             :key key
                                             :sort-priority (inc idx)})))
   :key))

(defn- sort-data-by-sort-order
  [data sort-order]
  (reduce (fn [acc {:keys [key direction]}]
            (let [sorted-colleciton (sort-by key acc)]
              (if (= direction :asc)
                (reverse sorted-colleciton)
                sorted-colleciton)))
          data
          (->> sort-order
               vals
               (sort-by :sort-priority)
               (reverse))))

(defn- render-table-header
  [{:keys [headers sort-order]}]
  [:thead
   [:tr
    (doall
     (for [{:keys [key display hide-sort]
            :or {hide-sort false}} headers]
       ^{:key key}
       [:th {:align :left
             :class [(:table-header-cell-container classes)]}
        [:div {:style {:display :flex}}
         [text/caption-20 :p display]
         (when-not (true? hide-sort)
           [button/icon-button-sm
            {:style {}
             :on-click #(update-sort-order sort-order key)}
            (if (= (get-in @sort-order [key :direction]) :desc)
              :chevron-down
              :chevron-up)])]]))]])

(defn- render-table-body
  [{:keys [data headers row-identifier row-marker]}]
  (let [{:keys [mark-row? mark-class]} (or row-marker
                                           {:mark-row? (constantly false)
                                            :mark-class ""})]
    [:tbody {:class [(:table-body-container classes)]}
     (for [row data]
       ^{:key (get row row-identifier)}
       [:tr {:class (cond-> [(:table-row-container classes)]
                      (mark-row? row)
                      (conj mark-class))}
        (for [{:keys [key is-component]
               :or {is-component false}} headers]
          ^{:key key}
          [:td {:class [(:table-cell-container classes)]}
           (if (true? is-component)
             (get row key)
             [text/caption-20 :p (get row key)])])])]))

(defn render
  [{:keys [headers]}]
  (let [sort-order (reagent/atom (get-default-sort-order headers))]
    (fn [{:keys [data headers row-identifier row-marker]}]
      (let [sorted-data (sort-data-by-sort-order data @sort-order)]
        [:table {:width "100%"}
         [render-table-header {:headers headers
                               :sort-order sort-order}]
         [render-table-body {:data sorted-data
                             :headers headers
                             :row-identifier row-identifier
                             :row-marker row-marker}]]))))
